import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";
import {convertObjectToFormData} from "../../../../Utilities/Api/apiUtility";

class serverOwnCatalogItemApi {

    static GetOwnCatalogItemById(ownCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `own/catalog/${ownCatalogItemId}`,
                requestTypes.GET,
            ),
        );
    }

    static AddOwnCatalogItem(ownCatalogItemModel: Record<string, unknown>) {
        const formData = convertObjectToFormData(ownCatalogItemModel);
        return sendRequest(
            requestOptions(`${config.URL}own/catalog/`,
                requestTypes.POST,
                formData,
                apiConstants.successMessage.catalog.CATALOG_ITEM_ADDED,
                apiConstants.contentType.MULTI,
            ),
        );
    }

    static UpdateOwnCatalogItem(ownCatalogItemModel: Record<string, unknown>) {
        const formData = convertObjectToFormData(ownCatalogItemModel);
        return sendRequest(
            requestOptions(`${config.URL}own/catalog/`,
                requestTypes.PUT,
                formData,
                apiConstants.successMessage.catalog.CATALOG_ITEM_UPDATED,
                apiConstants.contentType.MULTI,
            ),
        );
    }
}

export const ownCatalogItemApi = config.environment.MODE === config.modes.SERVER ? serverOwnCatalogItemApi : serverOwnCatalogItemApi;
